/* eslint-disable no-nested-ternary */
import { memo } from 'react';
import { useSelector } from 'react-redux';
import Flag from 'react-world-flags';
import { selectFooterStyle } from '../selectors';
import { FooterWrapper } from '../styled';
import { I_Portfolio } from '../typesIndex';

interface Props {
  user?: I_Portfolio['user'];
  slug?: I_Portfolio['slug'];
  isHideSlug?: boolean;
}

function Footer({ user, slug, isHideSlug }: Props) {
  const footerStyle = useSelector(selectFooterStyle);

  return (
    <FooterWrapper className="--footer">
      <div className={`portFooter footerStyle-${footerStyle || '1'}`}>
        <img
          className="--img"
          src={user?.cover || 'img/vtour.webp'}
          alt="cover"
          title="cover"
        />
        <div className="--profile">
          <a
            target="_blank"
            rel="noreferrer noopener"
            href={user?.home_page || ''}
            title="home page"
          >
            <div className="--avatar">
              <img
                src={user?.avatar || process.env.NEXT_PUBLIC_DEFAULT_AVATAR}
                alt="avatar"
                title="avatar"
              />
            </div>
          </a>
          <div className="--profileTxt">
            {(user?.first_name || user?.last_name || !isHideSlug) && (
              <div className="--name">
                <strong>
                  {user?.first_name || user?.last_name
                    ? `${user?.first_name} ${user?.last_name}`
                    : !isHideSlug
                    ? `@${slug}`
                    : ''}
                </strong>
                {(user?.first_name || user?.last_name) && !isHideSlug && (
                  <small>@{slug}</small>
                )}
              </div>
            )}
            {(user?.nationality || user?.address) && (
              <div className="--locale">
                <i aria-hidden className="far fa-location-dot" />
                {user?.address}{' '}
                {user?.nationality && (
                  <span className="--flag">
                    <Flag code={user?.nationality} height="12" />
                  </span>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </FooterWrapper>
  );
}

export default memo(Footer);
